export enum AccessType{
    All = 0,
    Owner = 1,
    Shared = 2
}